import { render, staticRenderFns } from "./reg-admin-RegV3.vue?vue&type=template&id=3dd8f5f7&"
import script from "./reg-admin-RegV3.vue?vue&type=script&lang=js&"
export * from "./reg-admin-RegV3.vue?vue&type=script&lang=js&"
import style0 from "./reg-admin-RegV3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCheckbox,VIcon,VImg,VSelect})
